"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizationKeyType = void 0;
var CustomizationKeyType;
(function (CustomizationKeyType) {
    CustomizationKeyType["Null"] = "null";
    CustomizationKeyType["INGO"] = "INGO";
    CustomizationKeyType["KLARNA"] = "KLARNA";
    CustomizationKeyType["LIDL"] = "LIDL";
    CustomizationKeyType["CALABRIO"] = "Calabrio";
    CustomizationKeyType["POSTKODLOTTERIET"] = "Postkodlotteriet";
    CustomizationKeyType["XAXIS"] = "Xaxis";
})(CustomizationKeyType || (exports.CustomizationKeyType = CustomizationKeyType = {}));
